export function initPortfolioList(loco) {
  const section = document.querySelector(".project-list");
  const preview = section?.querySelector(".portfolio-preview");
  const tiltEl = preview?.querySelector(".portfolio-preview__tilt");
  const img = preview?.querySelector(".portfolio-preview__img");
  if (!section || !preview || !tiltEl || !img || window.matchMedia("(max-width: 991px)").matches) return;

  const rows = section.querySelectorAll(".project-list__row[data-preview-image]");
  if (!rows.length) return;

  const lenis = loco?.lenisInstance;

  const getScrollY = () => {
    if (lenis && typeof lenis.scroll === "number") return lenis.scroll;
    return window.scrollY || document.documentElement.scrollTop || 0;
  };

  /** Smooth follow — higher = snappier */
  const LERP_POS = 0.1;
  /** Tilt follows target rotation with extra smoothing */
  const LERP_ROT = 0.22;
  const MAX_ROT = 11;
  /** Degrees per px of horizontal cursor–preview lag (gravity swing) */
  const ROT_LAG = 0.2;
  /** Degrees per px of scroll delta when cursor X is stable */
  const SCROLL_ROT = 0.18;
  /** Cursor X activity (px/frame) at which scroll tilt fully yields to lag tilt */
  const X_ACTIVE_THRESHOLD = 8;
  /** Min scroll delta (px/frame) to apply scroll tilt */
  const SCROLL_MIN_DELTA = 0.35;

  const smoothstep = (value) => value * value * (3 - 2 * value);

  let tx = window.innerWidth * 0.5;
  let ty = window.innerHeight * 0.5;
  let x = tx;
  let y = ty;
  let tr = 0;
  let r = 0;
  let lastScrollY = getScrollY();
  let lastTx = tx;
  let smoothTxActivity = 0;

  const show = (src, alt) => {
    img.src = src;
    img.alt = alt || "";
    section.classList.add("preview-active");
  };

  const hide = () => {
    section.classList.remove("preview-active");
  };

  window.addEventListener("mousemove", (event) => {
    tx = event.clientX + 22;
    ty = event.clientY - 26;
  });

  rows.forEach((row) => {
    row.addEventListener("mouseenter", () => {
      const src = row.dataset.previewImage;
      const alt = row.querySelector(".project-list__row__title")?.textContent?.trim() || "Project preview";
      if (!src) return;
      show(src, alt);
    });
    row.addEventListener("mouseleave", hide);
  });

  const tick = () => {
    const scrollY = getScrollY();
    const scrollDelta = scrollY - lastScrollY;
    const txDelta = Math.abs(tx - lastTx);
    lastScrollY = scrollY;
    lastTx = tx;

    x += (tx - x) * LERP_POS;
    y += (ty - y) * LERP_POS;
    preview.style.left = `${x}px`;
    preview.style.top = `${y}px`;

    if (section.classList.contains("preview-active")) {
      const lagX = tx - x;
      smoothTxActivity += (txDelta - smoothTxActivity) * 0.32;

      const xActivity = Math.min(1, smoothTxActivity / X_ACTIVE_THRESHOLD);
      const scrollInfluence = smoothstep(Math.max(0, 1 - xActivity));
      const scrollSpeed = smoothstep(Math.min(1, Math.abs(scrollDelta) / 10));

      const scrollContrib = Math.abs(scrollDelta) >= SCROLL_MIN_DELTA ? scrollDelta * SCROLL_ROT * scrollInfluence * scrollSpeed : 0;
      const lagContrib = lagX * ROT_LAG;

      tr = Math.max(-MAX_ROT, Math.min(MAX_ROT, scrollContrib + lagContrib));
    } else {
      tr = 0;
    }

    r += (tr - r) * LERP_ROT;
    tiltEl.style.transform = `rotate(${r}deg)`;

    requestAnimationFrame(tick);
  };

  tick();
}
